






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class CIndex extends Vue {
  @Prop() private topImg!: string;
}
